var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      class: _vm.bemBlock,
      on: {
        click: function($event) {
          $event.stopPropagation()
          return (function() {
            return _vm.$refs.imageSearchInput.click()
          })($event)
        }
      }
    },
    [
      _c("input", {
        ref: "imageSearchInput",
        class: [_vm.bemElement("image-search-input"), "visually-hidden"],
        attrs: { type: "file", accept: "image/png, image/jpeg", hidden: "" },
        on: {
          change: function($event) {
            return _vm.readBase64Image($event.target)
          }
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }